module.exports = __webpack_public_path__ + "static/Bailey-96ceb20e1c6518f6a8341f80e53bbed0.jpg";